export default __webpack_public_path__ + "static/brianf-bitmoji-24e8fa51e21d0e6f0e9ae8bc873a099f.png";